<div *ngIf="playURL !== undefined && howlerPlayer !== undefined" class="d-flex align-items-center w-100 gap-2">
  <button *ngIf="!howlerPlayer.isPlaying()" mat-icon-button (click)="this.play()">
    <mat-icon>play_arrow</mat-icon>
  </button>
  <button *ngIf="howlerPlayer.isPlaying()" mat-icon-button (click)="this.pause()">
    <mat-icon>pause</mat-icon>
  </button>

  <mat-slider class="flex-grow-1" [max]="howlerPlayer.getDuration()" [min]="0" [step]="0.1">
    <input matSliderThumb [value]="currentPosSeconds" (valueChange)="onSliderChange($event)" />
  </mat-slider>
</div>
<div *ngIf="playURL === undefined" class="row">
  <div class="col">
    <mat-progress-spinner diameter="24" [mode]="'indeterminate'"></mat-progress-spinner>
  </div>
</div>
